import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export const StickyCTA = ({
  showNewImage = false
}) => {
  return <div className="sticky-cta" data-id="element-261">
      <div className="sticky-cta-inner" data-id="element-262">
        <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-263">
          Clinical-Grade Copper Peptide Serum
        </h3>
        <div className="product-image mb-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg overflow-hidden" data-id="element-264">
          <div className="aspect-w-1 aspect-h-1 relative w-full" style={{
          paddingBottom: '100%'
        }} data-id="element-265">
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4" data-id="element-266">
              <img src="https://cdn.magicpatterns.com/uploads/8F5WM3mgGJmsWRwSyvyAws/Ανωνυμο_σχεδιο_(58).png" alt="Glisera Copper Renewal Serum - See visible skin improvement in 60 days or your money back" className="w-full h-full object-contain" data-id="element-267" />
            </div>
          </div>
        </div>
        <div className="customer-reviews mb-4" data-id="element-268">
          <div className="flex items-center justify-center mb-1" data-id="element-269">
            <div className="flex" data-id="element-270">
              {[1, 2, 3, 4, 5].map((star, index) => <StarIcon key={index} className={`h-5 w-5 ${index < 5 ? 'text-yellow-400' : 'text-gray-300'} fill-current`} data-id="element-271" />)}
            </div>
            <span className="ml-2 text-sm font-semibold" data-id="element-272">4.9 out of 5</span>
          </div>
          <p className="text-center text-sm text-gray-600" data-id="element-273">
            2,847 customer ratings
          </p>
        </div>
        <div className="ratings-breakdown mb-4 px-2" data-id="element-274">
          {[{
          label: '5★',
          percentage: 92
        }, {
          label: '4★',
          percentage: 6
        }, {
          label: '3★',
          percentage: 1
        }, {
          label: '2★',
          percentage: 0
        }, {
          label: '1★',
          percentage: 1
        }].map((rating, index) => <div key={index} className="flex items-center text-sm mb-1" data-id="element-275">
              <span className="w-8" data-id="element-276">{rating.label}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-2.5" data-id="element-277">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
              width: `${rating.percentage}%`
            }} data-id="element-278"></div>
              </div>
              <span className="w-8 text-right" data-id="element-279">{rating.percentage}%</span>
            </div>)}
        </div>
        <a href="https://www.tryglisera.com/products/glisera%E2%84%A2-copper-renewal-serum" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center mb-2 block" data-id="element-280">
          CHECK AVAILABILITY →
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-281">
          Limited time offer - 40% OFF + Fast FREE shipping
        </p>
      </div>
    </div>;
};